import * as actionTypes from 'src/old/actions';

const initialState = { subsidiaries: null };

const subsidiariesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUBSIDIARIES: {
      return {
        ...state,
        subsidiaries: action.response
      };
    }

    default: {
      return state;
    }
  }
};

export default subsidiariesReducer;
